/* @ngInject */
function UrlFilter(CONTEXT_PATH) {
    return function(url) {
        if (url.charAt(0) !== '/') {
            throw new Error(`Url '${url}' must be absolute`);
        }

        return CONTEXT_PATH + url;
    };
}

angular.module('egAngularUtils').filter('egUrl', UrlFilter);